angular.module('workflow.app')
  .filter 'populateTemplateURL', () ->
    return ( url, params ) ->
      result = url
      query = params.query
      workflow_step = params.workflow_step

      if query?
        encoded_query = encodeURIComponent(query)
        result = result.replace("{{query}}", encoded_query)
        result = result.replace("{{ query }}", encoded_query)

      if workflow_step?
        result = result.replace("{{workflow_step}}", workflow_step)
        result = result.replace("{{ workflow_step }}", workflow_step)

      return result
